<!-- src/components/ModuleGallery.vue -->
<template>
  <div class="module-container">
    <div v-for="(module, index) in filterNav(modules)" :key="index" class="module-item"
      :style="{
              backgroundImage: `url(${module.cover})`,
              backgroundColor: 'white' // 默认白色背景
            }">
      <div class="module-content">
        <h3 class="module-title">{{ module.name }}</h3>
        <div class="view-button" @click="handleClick(module)">立即查看</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getStore
  } from '../../utils/storage'

  export default {
    name: 'ModuleGallery',
    // props: {
    //   modules: {
    //     type: Array,
    //     required: true,
    //     validator: value => {
    //       return value.every(item => {
    //         return 'title' in item && 'backgroundImage' in item
    //       })
    //     }
    //   }
    // },
    data() {
      return {
        modules: this.$store.state.navList,
        // modules: [{
        //     title: '会议论坛',
        //     backgroundImage: 'https://example.com/products.jpg',
        //     link: '/products'
        //   },
        //   {
        //     title: '国内展会',
        //     backgroundImage: 'https://example.com/services.jpg',
        //     link: '/services'
        //   },
        //   {
        //     title: '国际展会',
        //     backgroundImage: 'https://example.com/about.jpg',
        //     link: '/about'
        //   }
        // ],
        isScrolling: true, // 用于控制是否滚动
      };
    },

    methods: {
      // 过滤导航栏列表
      filterNav(navlist) {
        const TARGET_CODES = new Set(['gjzh', 'hylt', 'gnzh']);

        const mainItem = navlist.find(item => item.mainColumn?.code === 'hyzl');
        if (!mainItem?.subColumn) return [];

        return mainItem.subColumn.filter(sub => TARGET_CODES.has(sub.code));
      },
      // 过滤子栏目
      // filterSubNav(sublist) {
      //   let filterList = []
      //   if (sublist) {
      //     console.log('sublist', sublist)
      //     // isHidden为0（正常显示)且不需要登录筛选
      //     filterList = sublist?.filter(item => (item.isHidden === 0 && item.isLogin === 0) || (item.isLogin === 1 &&
      //       this.userInfo))
      //     return filterList
      //   }
      // },
      handleClick(module) {
        // this.$emit('module-click', module)
        // 这里可以处理点击事件，例如路由跳转
        // console.log('点击了模块:', module.title)
        // 使用 localePath 处理多语言路由
        const path = this.localePath({ name: 'submenu-id', params: { id: module.code,other:module } })

        // 方式1：普通跳转
        this.$router.push(path)
        // this.$router.push(module.link)

        // 或者显示一个对话框
        // this.$message.success(`您点击了: ${module.title}`)
      }
    }
  }
</script>

<style scoped>
  .module-container {
    display: flex;
    justify-content: space-between;
    gap: 1vw;
    padding: 1vw;
    max-width: 80vw;
    margin: 0 auto;
  }

  .module-item {
    flex: 1;
    min-height: 18vw;
    background-size: cover;
    background-position: center;
    /* border-radius: 8px; */
    position: relative;
    overflow: hidden;
    /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .module-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* background: #fff; */
  }

  .module-content {
    position: relative;
    z-index: 1;
    text-align: center;
    color: #59C980;
    padding: 1vw;
  }

  .module-title {
    color: #59C980;
    font-weight: bold;
    font-size: 1.5rem;
    margin-bottom: 2vw;
  }

  .view-button {
    background: rgba(255, 255, 255, 0.2);
    color: #59C980;
    /* border: 1px solid white; */
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s ease;
  }

  .view-button:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    .module-container {
      flex-direction: column;
    }

    .module-item {
      margin-bottom: 5vw;
      min-height: 40vw;
    }
  }
</style>
